import { atom } from "jotai"
import { atomWithReset } from "jotai/utils"
import { z } from "zod"

export const vehicleSchema = z.object({
	make: z.string().min(1, "Make is required"),
	model: z.string().min(1, "Model is required"),
	year: z.coerce
		.number()
		.min(1900, "Year must be after 1900")
		.max(new Date().getFullYear() + 1, "Year cannot be in the future"),
})

export type VehicleModel = z.infer<typeof vehicleSchema>

export const defaultVehicle = undefined
export const vehicleDraftAtom = atomWithReset<VehicleModel | undefined>(defaultVehicle)
